import { uniqueId } from 'lodash';
import { useVariants } from './VariantsContext';

export function getInitialVariantOption(productType) {
  return {
    key: uniqueId(),
    name: '',
    image: null,
    status: 'enabled',
    files: [],
    description: '',
    additionalChargeAmount: '',
    discountedFromPrice: '',
    sku: '',
    stock: null,
    type: productType === 'subscription' ? 'recurring' : 'one_time',
  };
}

export function useVariantOption({ variantId, variantOptionId }) {
  const { state } = useVariants();

  const variantOption = state
    .find(variant => variant._id === variantId)
    ?.options.find(option => option._id === variantOptionId);

  return { variantOption };
}
